

import React from "react";
import {
    Table,
    Card
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function CompanySaleReportTable() {
    const reports = useReportsStore()
    const data = reports.businessCompanySaleReport.data;
    const loading = reports.businessCompanySaleReport.loading;


    const columns = [
        {
            title: "تاریخ صدور",
            dataIndex: "IssuanceDate",
            key: "IssuanceDate",
            width: 40,
            sorter: (a, b) => {
                let first = '';
                let second = '';
                a.IssuanceDate ? first = a.IssuanceDate : first = '';
                b.IssuanceDate ? second = b.IssuanceDate : second = '';
                return first.localeCompare(second)
            },
            render: data => data && (data.IssuanceDate === null ? "" : strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')))
        },
        {
            title: "نام رشته",
            dataIndex: "BranchName",
            key: "BranchName",
            width: 60,
            sorter: (a, b) => {
                let first = "";
                let second = "";
                a.BranchName ? (first = a.BranchName) : (first = "");
                b.BranchName ? (second = b.BranchName) : (second = "");
                return first.localeCompare(second);
            },

        },
        {
            title: "تعداد فروش",
            dataIndex: "SaleCount",
            key: "SaleCount",
            width: 30,
        },
        {
            title: "مبلغ فروش",
            dataIndex: "Amount",
            key: "Amount",
            width: 100,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: "مبلغ پرداختی",
            dataIndex: "SumPayment",
            key: "SumPayment",
            width: 110,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
    ];

    return (
        <Card>
            <Table
                style={{ overflowX: 'scroll' }}
                className="custom-table"
                size="small"
                bordered
                columns={columns}
                loading={loading}
                rowKey="Id"
                scroll={true}
                dataSource={data}
            />
        </Card>
    );
}


